import { render, staticRenderFns } from "./_my_4dbets.vue?vue&type=template&id=196198f8&lang=pug&"
import script from "./_my_4dbets.vue?vue&type=script&lang=js&"
export * from "./_my_4dbets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports